module.exports = {
  'PROD-US': {
    locale: 'en-us',
    apiDomain: '',
  },
  'PROD-CN': {
    locale: 'zh-cn',
    apiDomain: '',
  },
  localhost: {
    locale: 'zh-cn',
    // apiDomain: 'http://localhost:3000',
    apiDomain: '/api',
  },
};
